import React from "react";
import { Box, Typography, Grid, useMediaQuery, useTheme } from "@mui/material";

const PURPOSE_LABELS = {
  main_style: "Main Style",
  color_scheme: "Color Scheme",
  texture_detail: "Texture Detail",
  font_reference: "Font Reference",
  inspiration: "Inspiration",
  other: "Other",
};

const formatLabel = (img) => {
  if (img.purpose === "other" && img.customPurpose) {
    return img.customPurpose;
  }
  return PURPOSE_LABELS[img.purpose] || "Unlabeled";
};

const ReferenceImagePreviewList = ({ images = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!Array.isArray(images) || images.length === 0) return null;

  const imageSize = isMobile ? 60 : 100;

  return (
    <Box mt={2}>
      <Typography
        variant={isMobile ? "caption" : "body2"}
        fontWeight="bold"
        gutterBottom>
        Reference Images
      </Typography>

      <Grid container spacing={2}>
        {images.map((img, i) => {
          const label = formatLabel(img);

          return (
            <Grid item xs={6} sm={4} md={3} key={img.url || i}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                textAlign="left">
                <img
                  src={img.url}
                  alt={label}
                  title={label}
                  style={{
                    width: imageSize,
                    height: imageSize,
                    objectFit: "cover",
                    borderRadius: 8,
                  }}
                />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  mt={0.5}
                  sx={{ maxWidth: imageSize }}>
                  {label}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ReferenceImagePreviewList;
